import { MailingMode, PriceListFileType, } from '@/admin/modules/priceLists/models';
import { getEnumValuesAsArray, getValidEnumValues } from '@/core/utils/convert';
import { array, boolean, date, emptyToZero, minusSignToNull, number, object, string, strongEmail, } from '@/core/utils/validation';
import { t } from '@/core/localization';
const schema = object({
    exportPriceListId: number().integer().required(),
    name: string().max(256).nullable().required(t('field.is.required.error')),
    subject: string()
        .max(256)
        .nullable()
        .when('useEmail', {
        is: false,
        then: (schema) => schema.optional(),
        otherwise: (schema) => schema.required(t('field.is.required.error')),
    }),
    // TODO: (later) It was good solution. But old backend is appeared to return `bad request` when `subject` or
    // `fileName` is empty, however backend still saves priceList.
    // fileName: string()
    // 	.max(256)
    // 	.nullable()
    // 	.when('useEmail', {
    // 		is: false,
    // 		then: (schema) => schema.optional(),
    // 		otherwise: (schema) => schema.min(2).required(t('field.is.required.error')),
    // 	}),
    fileName: string().min(2).max(256).nullable().required(t('field.is.required.error')),
    fileType: number().oneOf(getValidEnumValues(PriceListFileType)).required(),
    // Is used instead of PriceListUpdate's `includedPricelists` property for edit purposes.
    includedPriceListsCombined: array()
        .of(object({
        pricelistId: number().integer().positive().required(),
        markup: number()
            .typeError('The field must be a number')
            .integer()
            //
            // Handling negative value block
            .min(-1_000_000_000_000)
            .max(1_000_000_000_000)
            .transform(minusSignToNull)
            //
            //
            .nullable()
            .defined(),
        logo: string().required(),
        checked: boolean().required(),
        // not required to check fields but still exist in interface
        name: string().nullable().defined(),
        supplierName: string().required(),
        updated: date().required(),
        deliveryTerms: number().integer().required(),
        rowCount: number().integer().nullable().required(),
        supplierPricelistMarkup: number().optional(),
    }))
        .test({
        message: t('at.least.one.supplier.price.list.is.required'),
        test: (combinedArray) => Boolean(combinedArray?.filter((item) => item.checked).length),
    })
        .required(),
    scheduleTime: array().of(string().min(5).max(5).required()).required(), // ['16:30:00', '20:30:00', '10:30:00'];
    useArchivation4Attaches: boolean().required(),
    mailingMode: number().oneOf(getEnumValuesAsArray(MailingMode)).required(),
    emails: array().of(strongEmail).required(), // ['stock_auto@autostels.ru'];
    useEmail: boolean().required(),
    useFtp: boolean().required(),
    ftpHost: string()
        .max(512)
        .when('useFtp', {
        is: false,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required('Host is required.'),
    }),
    ftpPort: string()
        .tcpIpPortAsString()
        .when('useFtp', {
        is: false,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required('Port is required.'),
    }),
    ftpLogin: string()
        .max(256)
        .when('useFtp', {
        is: false,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required('Login is required.'),
    }),
    ftpPassword: string()
        .max(256)
        .when('useFtp', {
        is: false,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required('Password is required.'),
    }),
    ftpDirectory: string().max(256).optional(),
    markup: number()
        .typeError('The field must be a number')
        .integer()
        //
        // Handling negative value block
        .min(-1_000_000_000_000)
        .max(1_000_000_000_000)
        .transform(minusSignToNull)
        //
        //
        .nullable()
        .notRequired()
        .transform(emptyToZero),
    markupAbsolute: number()
        .typeError('The field must be a number')
        .integer()
        .min(0)
        .nullable()
        .notRequired()
        .transform(emptyToZero),
    excludedBrands: array().of(string().required()).required(),
    excludedArticles: array().of(string().required()).required(),
    encoding: string().oneOf(['UTF-8', 'WINDOWS-1251']).required(),
    maxPrice: number().typeError('The field must be a number').integer().min(0).nullable().notRequired().transform(emptyToZero),
    minPrice: number().typeError('The field must be a number').integer().min(0).nullable().notRequired().transform(emptyToZero),
    isQuantityLimit: boolean().required(),
    quantityLimit: number().typeError('The field must be a number').integer().min(0).nullable().notRequired(),
    colorGroup: object({
        key: string()
            .oneOf(['orange', 'yellow', 'lime', 'teal', 'grey', 'brown', 'sky', 'violet'])
            .required(),
        title: string().defined(),
    })
        .nullable()
        .defined(),
});
const defaultValues = {
    exportPriceListId: 0,
    name: '',
    subject: null,
    fileName: null,
    fileType: PriceListFileType.Txt,
    includedPriceListsCombined: [],
    scheduleTime: [],
    useArchivation4Attaches: false,
    mailingMode: MailingMode.Daily,
    emails: [],
    useEmail: true,
    useFtp: false,
    ftpHost: '',
    ftpPort: '',
    ftpLogin: '',
    ftpPassword: '',
    ftpDirectory: '',
    markup: null,
    markupAbsolute: null,
    excludedBrands: [],
    excludedArticles: [],
    encoding: 'UTF-8',
    maxPrice: null,
    minPrice: null,
    isQuantityLimit: false,
    quantityLimit: null,
    colorGroup: null,
};
export { defaultValues, schema };
